/**
 * all states from store
 */
export default {
  notifications: {},
  notificationsOnRequest: false,
};
